export default {
	title: "Metodi di Pagamento",
	tips: "Caro utente, per favore compila il tuo indirizzo ERC20/TRC20. Non inserire i dettagli del tuo conto bancario e la tua password",
	form: {
		TransactionPassword: "Password di Transazione",
		Address: "Indirizzo del Portafoglio"
	},
	label: [
		"Nome della Banca",
		"Codice Filiale",
		"Nome Filiale",
		"Tipo di Deposito",
		"Numero di Conto",
		"Titolare del Conto"
	],
	tabs: ["Carta di Credito", "Rete"],
	delete: "Elimina",
	default: "Predefinito",
	create: "Crea",
	type: "Tipo di Prelievo",
	verifying: "verifica in corso",
	VerifyWalletAddress: "Verifica indirizzo del portafoglio",
	defaultAccount: "Conto di Prelievo Predefinito",
	deleteMsg: "Sei sicuro di voler eliminare?"
};
